import BackButton from "@src/components/_shared/BackButton";
import Container from "@src/components/_shared/Container";
import BlockTitle from "@src/components/_shared/UI/BlockTitle";
import useRegistrationStore from "@src/stores/registrationStore";
import Subtitle from '@src/components/_shared/UI/Subtitle';
import { Form, Formik } from 'formik';
import Input from '@src/components/_shared/UI/Input';
import ValidateButton from '@src/components/_shared/UI/ValidateButton';
import useNavigationStore from "@src/stores/navigationStore";

type JobTitleProps = {
    setJobTitle: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function JobTitle({ setJobTitle }: JobTitleProps) {
    const { setField, registration } = useRegistrationStore();
    const { setBlock } = useNavigationStore();

    const _onGoBack = () => {
        setJobTitle(false);
    };

    return (
        <Container>
            <BackButton onClick={_onGoBack}/>
            <BlockTitle title="Intitulé du poste" />
            <Subtitle content="Indiquez l’intitulé du poste " />
            <Formik
                initialValues={{
                    job_title: registration.person.professional.job_title,
                }}
                onSubmit={(values) => {
                    setField('person.professional', { ...registration.person.professional, job_title: values.job_title });
                    setBlock('FinancialJob');
                    setJobTitle(false);
                }}
            >
                {({ handleChange, handleSubmit, values }) => {
                    return (
                        <Form id="jobTitleForm" autoComplete="off" className="registerForm">
                            <Input
                                title="Intitulé du poste"
                                name="job_title"
                                id="job_title"
                                width="100%"
                                type="text"
                                placeholder="Ex: Développeur Web"
                                value={values.job_title}
                                onChange={handleChange('job_title')}
                                clearInput={() => handleChange('job_title')('')}
                                maxLength={80}
                            />
                            <ValidateButton title="Continuer" disabled={!values.job_title} onClick={handleSubmit} />
                        </Form>
                    )
                }}
            </Formik>
        </Container>
    )
}
